import { helper } from '@ember/component/helper';

export function posNegClass([value, inverse]: [number, boolean]) {
  if (value === 0) {
    return null;
  }
  if (value > 0) {
    return inverse ? 'danger' : 'success';
  } else {
    return inverse ? 'success' : 'danger';
  }
}

export default helper(posNegClass);
